<template>
	<div>
		<div class="main_navbar">
			<router-link to="/">
				<img v-if="cLang=='en'" src="@/assets/images/logo_en.png" class="logo" />
				<img v-else src="@/assets/images/logo.png" class="logo" />
			</router-link>
			<img src="../assets/images/menu.png" class="menus" @click="showNavChange" />
			<div class="mobilenavbar" :class="showNav?'on':''">
				<img src="../assets/images/closeww.png" class="closea" @click="hideNavChange" />
				<el-menu text-color="#999" active-text-color="#1991bf" :unique-opened="true" :router="true" :default-active="activeIndex" :default-openeds="openedSubmenu">
					<template v-for="(item, index) in navbar">
						<el-submenu v-if="item.child.length" :key="'submenu-'+index" class="submenu" :index="index">
							<template slot="title">
								<img :src="item.icon" class="icon" />
								<img :src="item.activeicon" class="icon1" />
								<span>{{ item.name }}</span>
							</template>
							<el-menu-item v-for="(itm, idx) in item.child" :index="itm.link" :key="idx" @click.native="hideNavChange">
								{{ itm.name }}
							</el-menu-item>
						</el-submenu>
						<el-menu-item v-else-if="item.link == '/s'" :key="'item-s-'+index" @click.native="hideNavChange1(item.name)">
							<img :src="item.icon" class="icon" />
							<img :src="item.activeicon" class="icon1" /> {{ item.name }}
						</el-menu-item>
						<el-menu-item v-else :key="'item-'+index" :index="item.link" @click.native="hideNavChange(item.name)">
							<img :src="item.icon" class="icon" />
							<img :src="item.activeicon" class="icon1" /> {{ item.name }}
						</el-menu-item>
					</template>
				</el-menu>
			</div>
		</div>
		<div class="nullbox"></div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import {
		Message
	} from 'element-ui';
	import {
		Loading
	} from 'element-ui';
	export default {
		name: 'navbar',
		data() {
			return {
				showNav: false,
				cLang: null,
				confiogs: {
					classroomUrl:"https://ptestudy.com/courses-single.php",
					relationUrl:"https://ptestudy.com/index.php#contact"
				},
				navbar: [],
			}
		},
		created() {
			this.updateNavbarData();
		},
		mounted() {
			this.cLang = !localStorage.getItem("lang") ? "ch" : localStorage.getItem("lang");
			this.getqueryConfig();
		},
		watch: {
			'$i18n.locale': function(newVal) {
				this.cLang = newVal;
				this.updateNavbarData();
			},
			'$store.state.lang': function(newVal) {
				this.cLang = newVal;
				this.updateNavbarData();
			}
		},
		computed: {
//			navbar() {
//				return this.$store.state.navbar;
//			},
			activeIndex() {
				let path = this.$route.path
				const query = this.$route.query
				if(path === '/Writing_word_info') {
					path = '/Writing_word'
				}
				if(path === '/videoinfo') {
					path = '/video'
				}
				if(path === '/userinfo_collect_info') {
					path = '/userinfo_collect'
				}
				if(path === '/memory_info') {
					path = '/memory'
				}

				const list = [{
						value: '口语',
						valueEN: 'speaking',
						keys: '/writing_practice?type=0&g=1'
					},
					{
						value: '写作',
						valueEN: 'writing',
						keys: '/writing_practice?type=1&g=1'
					},
					{
						value: '阅读',
						valueEN: 'reading',
						keys: '/writing_practice?type=2&g=1'
					},
					{
						value: '听力',
						valueEN: 'listening',
						keys: '/writing_practice?type=3&g=1'
					},
				]
				if(path === '/writing_practiceinfo') {
					// 真题练习题目列表
					const types = query.types
					const match = list.find(item => item.value === types)

					path = match.keys
				}
				
				if(path === '/writing_practiceinfo1') {
					path = '/writing_practice?type=-1&g=1'
				}
				
				if(path === '/userinfo_history_cj' || path === '/userinfo_studyPlan_ai') {
					path = '/userinfo_studyPlan'
				}
				if(path === '/vip') {
					path = '/userinfo'
				}
				

				if(path === '/writing_practice') {
					const type = query.type
					path = path + `?type=${type}&g=1`
				}

				if(path === '/courseInfo') {
					const type = query.types
					const match = list.find(item => item.value === type)
					if(match) {
						path = match.keys
					} else {
						if(query.types == 'package') {
							path = '/package_test'
						}
						if(query.types == 'homework') {
							path = '/homework'
						}
						if(query.infoType == 'kshy') {
							path = '/memory'
						}
						if(query.infoType == 'wdsc') {
							path = '/userinfo_collect'
						}
						if(query.infoType == 'studyplan') {
							path = '/userinfo_studyPlan'
						}
						if(query.infoType == 'gltm') {
							path = '/Writing_word'
						}
					}
				}
				return path
			},
			openedSubmenu() {
				const query = this.$route.query || {};
				const pathList = ['/writing_practice', '/writing_practiceinfo', '/courseInfo', '/writing_practiceinfo1']
				let path = this.$route.path || '';
				
				if(path == '/courseInfo') {
					if(query.types != 'package' && query.infoType != 'wdsc' && query.types != 'homework' && query.infoType != 'kshy' && query.infoType != 'studyplan' && query.infoType != 'gltm') {
						return [1]
					}
					return [];
				} else if(path == '/userinfo_collect' || path == '/vip' || path == '/userinfo_studyPlan_ai' || path == '/userinfo_history_cj' || path == '/userinfo' || path == '/userinfo_studyPlan'  || path == '/memory_info'|| path == '/memory' || path == '/my_note' || path == '/userinfo_collect_info') {
					return [9]
				} else {
					return pathList.includes(path) ? [1] : []
				}
			}
		},
		methods: {
			updateNavbarData() {
				this.navbar = [{
					name: this.$t('font1'),
					icon: require('@/assets/images/week_111.png'),
					activeicon: require('@/assets/images/index_21.png'),
					exact: true,
					link: '/',
					child: []
				}, {
					name: this.$t('font2'),
					icon: require('@/assets/images/index_765.png'),
					activeicon: require('@/assets/images/ztactive.png'),
					exact: false,
					link: '/writing_practice',
					show: false,
					child: [{
						name: this.$t('all'),
						link: '/writing_practice?type=-1&g=1'
					}, {
						name: this.$t('koyu'),
						link: '/writing_practice?type=0&g=1'
					}, {
						name: this.$t('xiezuo'),
						link: '/writing_practice?type=1&g=1'
					}, {
						name: this.$t('yuedu'),
						link: '/writing_practice?type=2&g=1'
					}, {
						name: this.$t('tingli'),
						link: '/writing_practice?type=3&g=1'
					}]
				}, {
					name: this.$t('font3'),
					icon: require('@/assets/images/index_32.png'),
					activeicon: require('@/assets/images/bzactive_03.png'),
					exact: false,
					link: '/week',
					child: []
				},{
					name: this.$t('font11'),
					icon: require('@/assets/images/index_765.png'),
					activeicon: require('@/assets/images/ztactive.png'),
					exact: false,
					link: '/today',
					child: []
				}, {
					name: this.$t('font4'),
					icon: require('@/assets/images/index_766.png'),
					activeicon: require('@/assets/images/ztactive_03.png'),
					exact: false,
					link: '/package_test',
					child: []
				}, {
					name: this.$t('font5'),
					icon: require('@/assets/images/index_763.png'),
					activeicon: require('@/assets/images/ztsactive_03.png'),
					exact: false,
					link: '/Writing_word',
					child: []
				}, {
					name: this.$t('font8'),
					icon: require('@/assets/images/index_60.png'),
					activeicon: require('@/assets/images/index_60.png'),
					exact: true,
					link: '/onlinevideo?type=直播',
					child: []
				}, {
					name: this.$t('font6'),
					icon: require('@/assets/images/index_764.png'),
					activeicon: require('@/assets/images/spactive_03.png'),
					exact: true,
					link: '/video?type=录播',
					child: []
				}, {
					name: this.$t('font7'),
					icon: require('@/assets/images/index_58.png'),
					activeicon: require('@/assets/images/zyactive_03.png'),
					exact: false,
					link: '/homework',
					child: []
				}, {
					name: this.$t('font9'),
					icon: require('@/assets/images/index_65.png'),
					activeicon: require('@/assets/images/index_65.png'),
					exact: false,
					link: '/s',
					child: []
				},{
					name: this.$t('forum'),
					icon: require('@/assets/images/forum_d.png'),
					activeicon: require('@/assets/images/forum_a.png'),
					exact: false,
					link: '/forum',
					child: []
				}, {
					name: this.$t('font10'),
					icon: require('@/assets/images/index_73.png'),
					activeicon: require('@/assets/images/gractive_03.png'),
					exact: false,
					link: '/userinfo',
					show: false,
					child: [{
						name: this.$t('userinfo'),
						link: '/userinfo'
					}, {
						name: this.$t('myshoucang'),
						link: '/userinfo_collect'
					}, {
						name: this.$t('xxjh'),
						link: '/userinfo_studyPlan'
					}, {
						name: this.$t('mybiji'),
						link: '/my_note'
					}, {
						name: this.$t('kaoshihuiyi'),
						link: '/memory'
					}]
				}];
			},
			jumpUrl(url) {
				let path = window.location.protocol + '//' + url
				window.location.href = path
			},
			getqueryConfig() {
				protal.getqueryConfig().then(res => {
					if(res.code == 200) {
						console.log(res)
						this.confiogs = res.result

					}
				})
			},
			hideNavChange1(name) {
				if(name == '直播课堂') {
					console.log(name)
					this.jumpUrl(this.confiogs.classroomUrl)
				}
				if(name == '联系我们') {
					console.log(name)
					this.jumpUrl(this.confiogs.relationUrl)
				}
			},
			hideNavChange(name) {

				this.showNav = false
				setTimeout(() => {
					this.$store.commit("showNavsBtn", true);
				}, 200)
			},
			showNavChange() {
				this.showNav = true
				this.$store.commit("showNavsBtn", false);
			}
		},
	}
</script>

<style lang="less" scoped>
	.main_navbar {
		padding-bottom: 1rem;
	}
	
	.el-submenu__title span {
		font-size: .14rem;
	}
	
	.el-menu-item {
		padding-left: .52rem !important;
		padding-right: 0!important;
		font-size: .14rem;
		height: .56rem;
		line-height: .56rem;
	}
	
	.el-submenu__title {
		font-size: .14rem;
		height: .56rem;
		line-height: .56rem;
	}
	
	.submenu {
		.el-menu-item {
			padding-left: .84rem !important;
		}
	}
	
	.el-menu-item img {
		width: .16rem;
		margin-right: .12rem !important;
	}
	
	.el-menu-item .icon,
	.submenu .icon {
		margin-right: .12rem !important;
		width: .16rem;
	}
	
	.el-menu-item,
	.submenu {
		/deep/ .el-submenu__title {
			padding-left: .52rem !important;
			padding-right: 0!important;
			font-size: .14rem;
			height: .56rem;
			line-height: .56rem;
			&:hover,
			&.is-active {
				background: #E7F2F6;
				color: #1991bf !important;
			}
		}
		.icon {
			margin-right: 12px;
			display: inline;
		}
		.icon1 {
			margin-right: 12px;
			display: none;
		}
		&:hover,
		&.is-active {
			background: #E7F2F6;
			color: #1991bf!important;
			.icon {
				display: none;
			}
			.icon1 {
				display: inline;
			}
		}
	}
	/*.main_navbar {
		overflow: hidden;
		width: 260px;
		background: #fff;
		border-radius: 0 15px 15px 0;
		position: fixed;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 99;
		padding: 40px 0 0 0;
	}

	.main_navbar .logo {
		display: block;
		margin: 0 auto;
		margin-bottom: 85px;
	}

	.main_navbar>ul {
		overflow: hidden;
		width: 100%;
	}

	.main_navbar>ul li {
		overflow: hidden;
		position: relative;
		width: 100%;
		margin-bottom: 10px;
	}

	.main_navbar>ul li .down {
		width: 10px;
		height: 6px;
		background-image: url(~@/assets/images/down1.png);
		background-size: 100% 100%;
		position: absolute;
		right: 14px;
		top: 24px;
	}

	.main_navbar>ul li>a.router-link-active {
		background: #E7F2F6;
	}

	.main_navbar>ul li>a.router-link-active .icon {
		display: none;
	}

	.main_navbar>ul li>a.router-link-active .icon1 {
		display: block;
	}

	.main_navbar>ul li>a.router-link-active span {
		color: #1991bf;
	}

	.main_navbar>ul li>a.router-link-active::after {
		height: 30px;
	}

	.main_navbar>ul li.router-link-active .down {
		background-image: url(~@/assets/images/topblue_03.png);
	}

	.main_navbar>ul li.router-link-active .slides {
		display: block;
	}

	.main_navbar>ul li:hover>a {
		background: #E7F2F6;
	}

	.main_navbar>ul li:hover>a span {
		color: #1991bf;
	}

	.main_navbar>ul li:hover>a .icon {
		display: none;
	}

	.main_navbar>ul li:hover>a .icon1 {
		display: block;
	}

	.main_navbar>ul li:hover>a::after {
		height: 30px;
	}

	.main_navbar>ul li .slides {
		overflow: hidden;
		display: none;
	}

	.main_navbar>ul li .slides a {
		display: block;
		font-size: 14px;
		padding-left: 87px;
		color: #999999;
		line-height: 40px;
	}

	.main_navbar>ul li .slides a.on {
		color: #1991bf;
	}

	.main_navbar>ul li .slides a:hover {
		color: #1991bf;
	}

	.main_navbar>ul li>a {
		display: flex;
		align-items: center;
		height: 50px;
		position: relative;
		padding-left: 52px;
		cursor: pointer;
		box-sizing: border-box;
	}

	.main_navbar>ul li>a::after {
		content: '';
		width: 4px;
		height: 0px;
		background: #1991BF;
		border-radius: 5px;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		transition: all .2s;
	}

	.main_navbar>ul li>a img {
		display: block;
	}

	.main_navbar>ul li>a .icon {
		display: block;
	}

	.main_navbar>ul li>a .icon1 {
		display: none;
	}

	.main_navbar>ul li>a span {
		font-size: 15px;
		color: #999999;
		margin-left: 18px;
		transition: all .1s;
	}*/
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue